﻿// exports agentsSearchUtilities
define([
	'jquery',
	'pubsub',
	'generalUtilities',
    'moduleUtilities',
    'countriesData',
	'validator',
	'Handlebars',
    'text!agentsDistancePartial',
	'locationAutoCompleteControl'
], function agentsSearchUtilities(
	$,
	pubsub,
	generalUtilities,
    moduleUtilities,
    countriesData,
	validationUtilities,
	Handlebars,
    agentsDistancePartial
) {
	'use strict';

	// #region setup
	var module, selectors, values;

	module = {};
	module.private = {};
	module.properties = {};

	selectors = {};
	selectors.searchFormContainer = '.js-usersearch-search-inner';
	selectors.searchForm = '.js-usersearch-form'; //
	selectors.searchInputs = '.js-usersearch-input';
	selectors.searchFormSubmit = '.js-usersearch-submit';
	selectors.searchLocationInput = '.js-usersearch-location-input';
	selectors.searchLocationButton = '.js-usersearch-location-btn';
	selectors.searchFieldInput = '.js-usersearch-field-input';
	selectors.searchFormResetBtn = '.js-usersearch-reset-btn';
	selectors.distanceRange = '#range-input';
    selectors.distanceUnit = 'input[name=distanceUnit]';
    selectors.distanceConatiner = '.js-distance-container';

	values = {};

    Handlebars.registerPartial('agentsDistancePartial', agentsDistancePartial);
    values.agentsDistancePartialHtml = Handlebars.compile(agentsDistancePartial);
	// #endregion
	// #region utilities

	module.private.createRequest = function createRequest(formValues, user) {
        var request;

		request = formValues;

		// when adding any standard properties make sure to update the grid control so it doesnt render the total count
		// re_usersearch_grid_control.js (131)

		request.RecordCount = 33;

		switch (formValues._subjectType) {
			case 'group':
                request.GroupUniqueName = formValues._subject;
                request.RelationshipSearch = 0;
				break;
			case 'firm':
				request.FirmUniqueName = formValues._subject;
				break;
			default:
			// do nothing
        }

        if (generalUtilities.prop(user, 'UserId') && generalUtilities.prop(user,'PremiumPlus')) {
            request.FeaturedUserId = user.UserId;
        }

		return request;
    };
    module.private.renderDistanceDropDown = function (showDistance) {
        var $html;

        $html = values.agentsDistancePartialHtml({ showDistance: showDistance });

        $(selectors.distanceConatiner).html($html);
    }

	module.private.doSearch = function doSearch(source) {
		var request, requestOptions, $form, formValues, serviceObject, haveGeoPoint, haveGeoPoly;
 
		requestOptions = {
			intent: 'search'
        };

		$form = $(selectors.searchForm);

        formValues = validationUtilities.serializeObject($form);

		haveGeoPoint = formValues.Longitude && formValues.Latitude;
		haveGeoPoly =
			formValues.Longitude1 &&
			formValues.Latitude1 &&
			formValues.Longitude2 &&
			formValues.Latitude2 &&
			formValues.Longitude3 &&
			formValues.Latitude3 &&
			formValues.Longitude4 &&
			formValues.Latitude4;

        if (!haveGeoPoint && !haveGeoPoly && !formValues.CountryCode) {
            formValues._locationName = '';
            formValues.Distance = null;
            $form.find(selectors.searchLocationInput).val('');
            module.private.renderDistanceDropDown(false);
		}

        request = module.private.createRequest(formValues, generalUtilities.prop(window, 'RESAAS.User2'));

		if (typeof source === 'string' ) {
			request.source = source;
        }

		serviceObject = moduleUtilities.createServiceObject(request, module.properties, requestOptions);
		generalUtilities.disableAndWaitFor(selectors.searchFormSubmit, 'dataUserSearchBrowse');
		pubsub.publish('uiNeedsUserSearchBrowse', serviceObject);

		return true;
	};

	module.trackInMixpanel = function trackInMixpanel(query) {
		var arr, temp, keys, data;

		data = query.request;

		if (!data) {
			return false;
		}

		arr = [];
		temp = {};
		temp.source = data.source || 'manual';
		temp.from = window.pageType;
		temp.type = 'user-discovery';
		temp['search result count'] = query.response.Count;

		if (data._locationName && data._locationName !== '') {
			temp['search location'] = data._locationName;
		}
		if (data.Name && data.Name !== '') {
			temp['search name'] = data.Name;
		}
		if (data.Keywords && data.Keywords !== '') {
			temp['search Keywords'] = data.Keywords;
		}
		if (data.YearsOfExperience && data.YearsOfExperience !== '') {
			temp['search YearsOfExperience'] = data.YearsOfExperience;
		}
		if (data.RelationshipSearch && data.RelationshipSearch !== '') {
			temp['search RelationshipSearch'] = data.RelationshipSearch;
		}
		if (data.LanguagesSpoken && data.LanguagesSpoken !== '') {
			temp['search LanguagesSpoken'] = data.LanguagesSpoken;
		}
		if (data._subjectType && data._subjectType === 'group') {
            temp['search group'] = data._subject;
            temp['search group name'] = data._subjectName;
		}
		if (data._subjectType && data._subjectType === 'firm') {
            temp['search firm'] = data._subject;
            temp['search firm name'] = data._subjectName;
		}

		keys = Object.keys(data);
		keys.forEach(function keysForEach(key) {
			if (key === '_locationName' && data[key]) {
				arr.push('location');
			} else if (key === 'Name' && data[key]) {
				arr.push('name');
			} else if (key === 'Keywords' && data[key]) {
				arr.push('Keywords');
			} else if (key === 'YearsOfExperience' && data[key]) {
				arr.push('YearsOfExperience');
			} else if (key === '_subjectType' && data[key] === 'group') {
				arr.push('group');
			} else if (key === '_subjectType' && data[key] === 'firm') {
				arr.push('firm');
			}
		});

		temp.category = arr;

		pubsub.publish('mixpanel.Search', temp);

		return true;
	};

	module.private.setUpLocationAutocomplete = function setUpLocationAutocomplete() {
		var data;
		data = {
			textInputId: '_locationName',
			type: 'geocode',
			forceSelect: true,
			callbackFunction: module.private.handleLocationChanged,
			clearFunction: module.private.clearLocationInputs
		};

		pubsub.publish('uiWantsToSetupLocationAutocomplete', data);
	};

	module.private.clearLocationInputs = function clearLocationInputs() {
		var $form = $(selectors.searchForm);
		$form.find('input[name="Latitude"]').val('');
		$form.find('input[name="Longitude"]').val('');
		$form.find('input[name="Latitude1"]').val('');
		$form.find('input[name="Longitude1"]').val('');
		$form.find('input[name="Latitude2"]').val('');
		$form.find('input[name="Longitude2"]').val('');
		$form.find('input[name="Latitude3"]').val('');
		$form.find('input[name="Longitude3"]').val('');
		$form.find('input[name="Latitude4"]').val('');
        $form.find('input[name="Longitude4"]').val('');
        $form.find('input[name="CountryCode"]').val('');
        $form.find('input[name="SearchType"]').val('');
        module.private.renderDistanceDropDown(false);
	};

	module.private.updateLocationInputsSingleLatLng = function updateLocationInputsSingleLatLng(place) {
		var $form, lat, lng;
		$form = $(selectors.searchForm);
		lat = place.geometry.location.lat();
		lng = place.geometry.location.lng();

		$form.find('input[name="Latitude"]').val(lat);
		$form.find('input[name="Longitude"]').val(lng);
	};

	module.private.updateLocationInputsPolygonLatLng = function updateLocationInputsPolygonLatLng(place) {
		var $form, NElat, NElng, SWlat, SWlng, NWlat, NWlng, SElat, SElng;

		$form = $(selectors.searchForm);
		// get 2 points lat lng, calculate the other 2 points
		NElat = place.geometry.viewport.getNorthEast().lat();
		NElng = place.geometry.viewport.getNorthEast().lng();
		SWlat = place.geometry.viewport.getSouthWest().lat();
		SWlng = place.geometry.viewport.getSouthWest().lng();

		NWlat = NElat;
		NWlng = SWlng;
		SElat = SWlat;
		SElng = NElng;

		// update the form fields to draw a box, going counter-clockwise
		$form.find('input[name="Latitude1"]').val(NElat);
		$form.find('input[name="Longitude1"]').val(NElng);
		$form.find('input[name="Latitude2"]').val(NWlat);
		$form.find('input[name="Longitude2"]').val(NWlng);
		$form.find('input[name="Latitude3"]').val(SWlat);
		$form.find('input[name="Longitude3"]').val(SWlng);
		$form.find('input[name="Latitude4"]').val(SElat);
		$form.find('input[name="Longitude4"]').val(SElng);
	};

	// event handlers
	//-------------------------------------------

    module.private.handleFieldChanged = function handleFieldChanged(e) {
        var $form;
        if (generalUtilities.prop(e, 'target.name') === "RelationshipSearch") {
            $form = $(selectors.searchForm);
            if (e.target.value !== "0" && e.target.value !== "1" && e.target.value !== "2") {
                $form.find('input[name="_subject"]').val(e.target.value);
                if (e.target.getAttribute('data-searchtype') === 'firm') {
                    $form.find('input[name="_subjectType"]').val('firm');
                } else {
                    $form.find('input[name="_subjectType"]').val('group');
                }
                $form.find('input[name="_subjectName"]').val(e.target.getAttribute('data-groupname'));
            } else {
                $form.find('input[name="_subject"]').val('');
                $form.find('input[name="_subjectType"]').val('');
                $form.find('input[name="_subjectName"]').val(e.target.getAttribute(''));
            }
        }
		module.private.doSearch();
    };

	module.private.handleLocationChanged = function handleLocationChanged(place) {
        var adminAreaLevel, types, countryCode, i, component;
		if (generalUtilities.prop(place, 'geometry.location')) {
			// place is a locationAutocomplete.getPlace();
			types = generalUtilities.prop(place, 'types');
			adminAreaLevel = null;
			if (types) {
				adminAreaLevel = types[0];
			}

			// for state (administrative area level 1 to 5)
			if (adminAreaLevel && adminAreaLevel.indexOf('administrative_area_level_') > -1) {
                module.private.updateLocationInputsPolygonLatLng(place);
                module.private.renderDistanceDropDown(false);
				// for country
			} else if (adminAreaLevel === 'country') {
                module.private.updateLocationInputsPolygonLatLng(place);
                module.private.renderDistanceDropDown(false);
				// for address or city or neighborhoods etc
			} else {
                module.private.updateLocationInputsSingleLatLng(place);
                module.private.renderDistanceDropDown(true);
            }

            // find the country code
            if (place.address_components) {
                countryCode = null;
                for (i = 0; i < place.address_components.length; i++) {
                    component = place.address_components[i];
                    if (component.types[0] === 'country') {
                        countryCode = component.short_name;
                        $(selectors.searchForm)
                            .find('input[name="CountryCode"]')
                            .val(countryCode);
                        if (types && types.includes("country")) {
                            $(selectors.searchForm)
                                .find('input[name="SearchType"]')
                                .val(1);
                        } 
                        break;
                    }
                }
            }

			$(selectors.searchForm)
				.find('input[name="Name"]')
                .focus();

            module.private.doSearch();
        }
		
	};

	module.private.handleDataUserLocationBrowse = function handleDataUserLocationBrowse(e, data) {
		var $form;

		if (!data.lat || !data.lng || !data.addressName) {
			return;
		}
		$form = $(selectors.searchForm);
		if ($form) {
			$form.find('input[name="Latitude"]').val(data.lat);
			$form.find('input[name="Longitude"]').val(data.lng);
            $form.find('input[name="_locationName"]').val(data.addressName);
            $form.find('input[name="CountryCode"]').val(data.countryCode);
            $form.find('input[name="SearchType"]').val('');
            module.private.renderDistanceDropDown(true);
			module.private.doSearch();
		}
	};

	module.private.rowItemRemainder = function rowItemRemainder(data) {
		var remainingUsers, nonPremiumUsers;

		// if load more exist 
		if (data.response.Count > data.request.RecordCount && data.response.Data.length === data.request.RecordCount) {

			nonPremiumUsers = data.response.Data.filter(function premiumUsersNumbers(agent) {
				return agent.IsPremium === false
			}).length;

			remainingUsers = nonPremiumUsers % 3;

			return remainingUsers;
		}

		return 0;
    }

    module.private.getUserLocation = function getUserLocation(user) {
        var locationParts, countryName;

        locationParts = [];
        if (user.CountryId) {
            countryName = generalUtilities.localizeResource(countriesData.read({ id: user.CountryId }).resourceName);

            // add Address if it exists
            if (user.Address) {
                locationParts.unshift(user.Address);
            }

            // add City if it exists
            if (user.City) {
                locationParts.push(user.City);
            }

            // add State if it exists
            if (user.State) {
                locationParts.push(user.State);
            }

            locationParts.push(countryName);
        }

        return locationParts.length > 0 ? locationParts.join(', ') : '';
    };

	module.private.init = function init(e, data) {
		module.properties.guid = data && data.guid ? data.guid : generalUtilities.uuid();
	};

	module.bindHandleFieldChanged = function bindHandleFieldChanged() {
		$('body').off('change', selectors.searchFieldInput, module.private.handleFieldChanged);
		$('body').on('change', selectors.searchFieldInput, module.private.handleFieldChanged);
	};
	module.bindhandleDataUserLocationBrowse = function bindhandleDataUserLocationBrowse(){
		pubsub.subscribe('data.UserLocationBrowse', module.private.handleDataUserLocationBrowse);
	};

	module.setUpLocationAutocomplete = module.private.setUpLocationAutocomplete;
    module.doSearch = module.private.doSearch;
    module.getUserLocation = module.private.getUserLocation;
    module.renderDistanceDropDown = module.private.renderDistanceDropDown;

	pubsub.subscribe('uiWantsAgentsSearchControlInit', module.private.init);

	// #endregion
	return module;
});
